import React from 'react';

import L2Page from '../../../../templates/l2-page';
import Content from './_index.mdx';

export default (): React.JSX.Element => {
	return (
		<L2Page
			categorySlug="use-tokens-in-code"
			title="Use tokens in code"
			description="Learn how to set up and use design tokens in code."
			entries={[]}
		>
			<Content />
		</L2Page>
	);
};
